import { useState, useEffect } from 'react';
import BaseMarkdown from '@components/base/BaseMarkdown';
import useI18n, { LocaleTypes } from '@i18n';

import contentRU from './content_ru.md';
import contentEN from './content_en.md';

const TermsMarkdown: React.FC = () => {
    const { locale } = useI18n();
    const [markdown, setMarkdown] = useState<string>('');

    useEffect(() => {
        if (locale === LocaleTypes.ru) {
            setMarkdown(contentRU);
        } else {
            setMarkdown(contentEN);
        }
    }, [locale]);

    return <BaseMarkdown markdown={markdown} />;
};

export default TermsMarkdown;
